import { Component, computed, input } from '@angular/core';

/**
 * Tons por status. A Gestão de Termos usa Ativo/Inativo; qualquer outro valor cai
 * no cinza de `status-badge--fechada`, que é o padrão neutro.
 */
const STATUS_MODIFIER: Record<string, string> = {
  'Ativo': 'status-badge--ativa',
  'Inativo': 'status-badge--inativo',
};

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [],
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.scss',
})
export class StatusBadgeComponent {
  readonly status = input.required<string>();
  /** Texto exibido no badge — default para `status()` quando o próprio código já é legível. */
  readonly label = input<string>();

  readonly displayLabel = computed(() => this.label() ?? this.status());

  readonly badgeClasses = computed(() => {
    const modifier = STATUS_MODIFIER[this.status()] ?? 'status-badge--fechada';

    return `status-badge ${modifier}`;
  });
}
